var map = {
	"./anti-corruption.vue": [
		"06af",
		"chunk-a7df539a"
	],
	"./full-home.vue": [
		"2639",
		"chunk-5ab119ae"
	],
	"./general-politic.vue": [
		"98ce",
		"chunk-6b1a9f29",
		"chunk-2f711000"
	],
	"./green-politic.vue": [
		"b79c",
		"chunk-6b1a9f29",
		"chunk-2e80b108"
	],
	"./home.vue": [
		"6511",
		"chunk-2d0cfa15"
	],
	"./legal-advice.vue": [
		"08d5",
		"chunk-700bebd6"
	],
	"./logo-anim-phrase.vue": [
		"d996",
		"chunk-f37e2ca2"
	],
	"./mobile-home.vue": [
		"a864",
		"chunk-2b7f7824"
	],
	"./modern-slavery.vue": [
		"0b84",
		"chunk-15576815"
	],
	"./not-found.vue": [
		"63e6",
		"chunk-49a807fa"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;